import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
import { isString as e } from "../utils/isString.js";
var a = {
    iframeAttr: {
      allow: "autoplay; fullscreen",
      scrolling: "auto"
    }
  },
  i = function i() {
    var i;
    function l(t, a) {
      var i = a.src;
      if (!e(i)) return;
      var l = a.type;
      if (!l) {
        if (l || ("#" === i.charAt(0) ? l = "inline" : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? l = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) ? l = "pdf" : i.match(/\.(html|php)((\?|#).*)?$/i) && (l = "iframe")), !l) {
          var _t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i);
          _t && (i = "https://maps.google.".concat(_t[1], "/?ll=").concat((_t[2] ? _t[2] + "&z=" + Math.floor(parseFloat(_t[3])) + (_t[4] ? _t[4].replace(/^\//, "&") : "") : _t[4] + "").replace(/\?/, "&"), "&output=").concat(_t[4] && _t[4].indexOf("layer=c") > 0 ? "svembed" : "embed"), l = "gmap");
        }
        if (!l) {
          var _t2 = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
          _t2 && (i = "https://maps.google.".concat(_t2[1], "/maps?q=").concat(_t2[2].replace("query=", "q=").replace("api=1", ""), "&output=embed"), l = "gmap");
        }
        a.src = i, a.type = l;
      }
    }
    function o(e, l) {
      "iframe" !== l.type && "pdf" !== l.type && "gmap" !== l.type || function (e) {
        if (!i || !e.el || !e.src) return;
        var l = document.createElement("iframe");
        l.classList.add("f-iframe");
        for (var _i = 0, _Object$entries = Object.entries(function () {
            var e = null == i ? void 0 : i.getOptions().Html;
            return t(e) ? Object.assign(Object.assign({}, a), e) : a;
          }().iframeAttr || {}); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _e = _Object$entries$_i[0],
            _o = _Object$entries$_i[1];
          l.setAttribute(_e, _o);
        }
        l.onerror = function () {
          i && 1 === i.getState() && i.showError(e, "{{IFRAME_ERROR}}");
        }, l.src = e.src;
        var o = document.createElement("div");
        if (o.classList.add("f-html"), o.append(l), e.width) {
          var _t3 = "".concat(e.width);
          _t3.match(/^\d+$/) && (_t3 += "px"), o.style.maxWidth = "".concat(_t3);
        }
        if (e.height) {
          var _t4 = "".concat(e.height);
          _t4.match(/^\d+$/) && (_t4 += "px"), o.style.maxHeight = "".concat(_t4);
        }
        if (e.aspectRatio) {
          var _t5 = e.el.getBoundingClientRect();
          o.style.aspectRatio = "".concat(e.aspectRatio), o.style[_t5.width > _t5.height ? "width" : "height"] = "auto", o.style[_t5.width > _t5.height ? "maxWidth" : "maxHeight"] = "none";
        }
        e.contentEl = l, e.htmlEl = o, e.el.classList.add("has-html"), e.el.classList.add("has-iframe"), e.el.classList.add("has-".concat(e.type)), e.el.prepend(o), i.emit("contentReady", e);
      }(l);
    }
    function n(t, e) {
      var a, l;
      "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || (null == i || i.hideError(e), null === (a = e.contentEl) || void 0 === a || a.remove(), e.contentEl = void 0, null === (l = e.htmlEl) || void 0 === l || l.remove(), e.htmlEl = void 0);
    }
    return {
      init: function init(t) {
        i = t, i.on("addSlide", l), i.on("attachSlideEl", o), i.on("detachSlideEl", n);
      },
      destroy: function destroy() {
        null == i || i.off("addSlide", l), null == i || i.off("attachSlideEl", o), null == i || i.off("detachSlideEl", n), i = void 0;
      }
    };
  };
export { i as Html };